var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full_height"},[_c('el-button',{staticClass:"returnCls",attrs:{"icon":"el-icon-d-arrow-left","circle":""},on:{"click":_vm.backToLeftCom}}),(_vm.currentCom)?_c(_vm.currentCom,{ref:"com",tag:"component",attrs:{"conditions":_vm.conditions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }